import React from 'react';
import styles from './styles';
import {ToggleSwitchV2, Button} from '@xpertdox_js/xdcomponents';


const SubPanel = props => {

  // panel fields
  const options = props.settings.options.filter(option => option.id !== 'dt_group_checkbox');

  return(
    <div style={{
        ...styles.menuPanel,
        top: props.top,
        position: props.fixed ? 'fixed' : 'absolute',
        right: props.right,
      }}>
      <h6 style={styles.menuTitle}>{props.settings.title}</h6>
      <div style={styles.panelContent} key={props.settings.id}>
        {options && options.map((optionObj, i) => {
          return(
            optionObj.type && optionObj.type === 'toggle'
            ? <div key={optionObj.id + i} style={styles.switchMenuItem}>
                {/* header title */}
                <div style={styles.switchText}>
                  <span style={styles.switchTextContent}>{optionObj.text}</span>
                </div>
                {/* switch */}
                <div style={styles.switchButton}>
                  <ToggleSwitchV2
                    styles={styles.switchCompStyles}
                    condition={optionObj.condition}
                    setter={
                      props.settings.type === 'default'
                      ? optionObj.setter
                      : props.actions[optionObj.setter]
                    }
                    setterParam={optionObj.setterParam}
                    text={['On', 'Off']}
                  />
                </div>
              </div>

            : <div key={optionObj.id + i} style={styles.buttonMenuItem}>
                <Button
                  onClick={optionObj.setter || props.actions[optionObj.setter]}
                  clickParam={[optionObj.setterParam, props.data]}
                  styles={styles.miButton}
                  hoverStyles={styles.miButtonHov}
                  activeStyles={styles.miButtonAct}
                  focusStyles={styles.miButtonFoc}
                >
                  {optionObj.text}
                </Button>
              </div>
          )
        })}
      </div>
    </div>
  );
}

export default SubPanel;
